import { render, staticRenderFns } from "./SellAmount.vue?vue&type=template&id=38b0ca66&scoped=true"
import script from "./SellAmount.vue?vue&type=script&lang=js"
export * from "./SellAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0ca66",
  null
  
)

export default component.exports